<template><div id="app"><header class="app-header"><h1>视频监控系统</h1><button @click="showModal = true" class="add-stream-btn">添加视频流</button></header><main class="app-main"><VideoMonitor 
        :stream-url="currentStreamUrl"
        @error="handleVideoError"
      /></main><VideoStreamModal
      :visible="showModal"
      @confirm="handleConfirm"
      @cancel="showModal = false"
    /></div></template><script>import VideoStreamModal from './components/VideoStreamModal.vue'
import VideoMonitor from './components/VideoMonitor.vue'

export default {
  name: 'App',
  components: {
    VideoStreamModal,
    VideoMonitor
  },
  data() {
    return {
      showModal: false,
      currentStreamUrl: ''
    }
  },
  methods: {
    handleConfirm(streamUrl) {
      this.currentStreamUrl = streamUrl
      this.showModal = false
    },
    handleVideoError(error) {
      console.error('视频播放错误:', error)
      alert('视频播放失败，请检查视频流地址是否正确')
    }
  }
}
</script><style>* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background-color: #f0f2f5;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-header {
  background-color: #1890ff;
  color: white;
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.app-header h1 {
  font-size: 20px;
  font-weight: 600;
}

.add-stream-btn {
  background-color: white;
  color: #1890ff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  font-weight: 500;
}

.add-stream-btn:hover {
  background-color: #f5f5f5;
}

.app-main {
  flex: 1;
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.app-main > div {
  width: 100%;
  max-width: 1200px;
  height: 600px;
}</style>
